import { call, put, takeEvery } from "redux-saga/effects";

import { PaginateQuery, ResponseGenerator } from "../../interfaces";
import {
  ADD_CHAPTER,
  AddChapterAction,
  DELETE_CHAPTER,
  DeleteChapterAction,
  GET_CHAPTER,
  GetChapterAction,
  GetChaptersAction,
  UPDATE_CHAPTER,
  UpdateChapterAction,
  GetChaptersStatsAction,
  GET_CHAPTERS_STATS,
  GET_CHAPTERS,
  GET_CHAPTERS_SKILLS_STATS,
  GET_CHAPTERS_FLASH_CARDS_STATS,
  GetChaptersFlashCardsStatsAction,
  ToggleChapterStateAction,
  TOGGLE_CHAPTER_STATE,
  GET_CHAPTERS_LECTURES_STATS,
  GetChaptersLecturesStatsAction,
  GET_CHAPTER_LIST_BY_SUBJECT,
  GetChapterSelectListBySubjectAction,
  GetOrganizingChaptersAction,
  GET_ORGANIZING_CHAPTERS,
} from "./actionTypes";
import {
  addChapterError,
  addChapterSuccess,
  deleteChapterError,
  deleteChapterSuccess,
  getChapterError,
  getChapterSelectListBySubjectError,
  getChapterSelectListBySubjectSuccess,
  getChapterSuccess,
  getChaptersError,
  getChaptersFlashCardsStatsError,
  getChaptersFlashCardsStatsSuccess,
  getChaptersLecturesStatsError,
  getChaptersLecturesStatsSuccess,
  getChaptersSkillsStatsError,
  getChaptersSkillsStatsSuccess,
  getChaptersStatsError,
  getChaptersStatsSuccess,
  getChaptersSuccess,
  getOrganizingChaptersError,
  getOrganizingChaptersSuccess,
  toggleChapterStateError,
  toggleChapterStateSuccess,
  updateChapterError,
  updateChapterSuccess,
} from "./actions";
import {
  addChapter,
  deleteChapter,
  getChapter,
  getChaptersStats,
  getChapters,
  updateChapter,
  getChaptersSkillsStats,
  toggleChapterState,
  getChaptersFlashCardsStats,
  getChaptersLecturesStats,
  getChaptersSelectListBySubject,
  getOrganizingChapters,
} from "../../helpers/backend_helper";

function* getChaptersSaga({
  payload: { request, history },
}: GetChaptersAction) {
  try {
    const response: ResponseGenerator = yield call(
      getChapters,
      request as PaginateQuery
    );
    yield put(getChaptersSuccess(response.data));
  } catch (error) {
    yield put(getChaptersError(error));
  }
}

function* getChaptersStatsSaga({
  payload: { subjectId, history },
}: GetChaptersStatsAction) {
  try {
    const response: ResponseGenerator = yield call(getChaptersStats, subjectId);
    yield put(getChaptersStatsSuccess(response.data));
  } catch (error) {
    yield put(getChaptersStatsError(error));
  }
}

function* getChapterSaga({ payload: { id, history } }: GetChapterAction) {
  try {
    const response: ResponseGenerator = yield call(getChapter, id);
    yield put(getChapterSuccess(response.data));
  } catch (error) {
    yield put(getChapterError(error));
  }
}

function* addChapterSaga({ payload: { request, history } }: AddChapterAction) {
  try {
    yield call(addChapter, request);
    yield put(addChapterSuccess());
  } catch (error) {
    yield put(addChapterError(error));
  }
}

function* updateChapterSaga({
  payload: { id, request, history },
}: UpdateChapterAction) {
  try {
    yield call(updateChapter, id, request);
    yield put(updateChapterSuccess());
  } catch (error) {
    yield put(updateChapterError(error));
  }
}

function* deleteChapterSaga({ payload: { id, history } }: DeleteChapterAction) {
  try {
    yield call(deleteChapter, id);
    yield put(deleteChapterSuccess());
  } catch (error) {
    yield put(deleteChapterError(error));
  }
}

function* getChaptersSkillsStatsSaga({
  payload: { subjectId, history },
}: GetChaptersStatsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getChaptersSkillsStats,
      subjectId
    );
    yield put(getChaptersSkillsStatsSuccess(response.data));
  } catch (error) {
    yield put(getChaptersSkillsStatsError(error));
  }
}

function* getChaptersFlashCardsStatsSaga({
  payload: { subjectId, history },
}: GetChaptersFlashCardsStatsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getChaptersFlashCardsStats,
      subjectId
    );
    yield put(getChaptersFlashCardsStatsSuccess(response.data));
  } catch (error) {
    yield put(getChaptersFlashCardsStatsError(error));
  }
}

function* toggleChapterStateSaga({
  payload: { id, history },
}: ToggleChapterStateAction) {
  try {
    yield call(toggleChapterState, id);
    yield put(toggleChapterStateSuccess(id));
  } catch (error) {
    yield put(toggleChapterStateError(error));
  }
}

function* getChaptersLecturesStatsSaga({
  payload: { subjectId, history },
}: GetChaptersLecturesStatsAction) {
  try {
    const response: ResponseGenerator = yield call(
      getChaptersLecturesStats,
      subjectId
    );
    yield put(getChaptersLecturesStatsSuccess(response.data));
  } catch (error) {
    yield put(getChaptersLecturesStatsError(error));
  }
}

function* getChapterSelectListBySubjectSaga({
  payload: { subjectId },
}: GetChapterSelectListBySubjectAction) {
  try {
    const response: ResponseGenerator = yield call(
      getChaptersSelectListBySubject,
      subjectId
    );
    yield put(getChapterSelectListBySubjectSuccess(response.data));
  } catch (error) {
    yield put(getChapterSelectListBySubjectError(error));
  }
}

function* getOrganizingChaptersSaga({
  payload: { query, subjectId, history },
}: GetOrganizingChaptersAction) {
  try {
    const response: ResponseGenerator = yield call(
      getOrganizingChapters,
      subjectId,
      query as PaginateQuery
    );
    yield put(getOrganizingChaptersSuccess(response.data));
  } catch (error) {
    yield put(getOrganizingChaptersError(error));
  }
}

function* ChapterSaga() {
  yield takeEvery(GET_CHAPTERS, getChaptersSaga);
  yield takeEvery(GET_CHAPTER, getChapterSaga);
  yield takeEvery(GET_CHAPTERS_STATS, getChaptersStatsSaga);
  yield takeEvery(ADD_CHAPTER, addChapterSaga);
  yield takeEvery(UPDATE_CHAPTER, updateChapterSaga);
  yield takeEvery(DELETE_CHAPTER, deleteChapterSaga);
  yield takeEvery(GET_CHAPTERS_SKILLS_STATS, getChaptersSkillsStatsSaga);
  yield takeEvery(
    GET_CHAPTERS_FLASH_CARDS_STATS,
    getChaptersFlashCardsStatsSaga
  );
  yield takeEvery(TOGGLE_CHAPTER_STATE, toggleChapterStateSaga);
  yield takeEvery(GET_CHAPTERS_LECTURES_STATS, getChaptersLecturesStatsSaga);
  yield takeEvery(
    GET_CHAPTER_LIST_BY_SUBJECT,
    getChapterSelectListBySubjectSaga
  );
  yield takeEvery(GET_ORGANIZING_CHAPTERS, getOrganizingChaptersSaga);
}

export default ChapterSaga;
